import React from 'react'
import { components, type OptionProps } from 'react-select'

import {
  type SelectDisplayOption,
  SelectDisplayRow,
} from '../../../Selects/SelectDisplay/SelectDisplay'

export const Option = <OptionType,>(props: OptionProps<OptionType>) => {
  const { selectProps, selectOption, data } = props,
    { value, optionKeyName, labelKeyName } = selectProps as {
      value: OptionType
      optionKeyName: keyof OptionType
      labelKeyName: keyof OptionType
    }

  const transformedData = {
    ...data,
    label: data[labelKeyName] as string,
    name: data[optionKeyName] as string,
  }

  return (
    <components.Option {...props}>
      <SelectDisplayRow
        active={value?.[optionKeyName] as keyof OptionType}
        option={transformedData}
        callout={(option: OptionType) =>
          selectOption({
            ...option,
            [labelKeyName]: (option as SelectDisplayOption).label,
            [optionKeyName]: (option as SelectDisplayOption).name,
          })
        }
      />
    </components.Option>
  )
}

export default Option
